import React from 'react';
import { Row, Col } from 'react-flexbox-grid';
import { Parallax } from 'react-scroll-parallax';
import styles from './VideoBlock.styl';

const VideoBlock = props => {
  return (
    <div className={styles.videoContainer}>
      <Row className={styles.wrapper}>
        <Col>
          <Parallax
            className={styles.parallax}
            offsetYMax={15}
            offsetYMin={-20}
            tag="figure"
          >
            <video
              className={styles.video}
              src="https://s3-us-west-2.amazonaws.com/ifaw-congress/Dominos.mp4"
              autoPlay
              loop
              muted
            />
          </Parallax>
        </Col>
        <Col xs={12} md={6} mdOffset={6} className={styles.textBlock}>
          <p className={styles.subText}>Video</p>
          <h1 className={styles.headline}>It affects us, too</h1>
          <p className={styles.text}>
            Saving species from extinction is about more than preserving
            iconic wildlife for generations to come. We are also protecting
            integral parts of the ecosystems that provide the air we breathe,
            the water we drink, the parks we enjoy and the medicine we need.
          </p>
        </Col>
      </Row>
    </div>
  );
};

export default VideoBlock;



// WEBPACK FOOTER //
// ./src/components/static/VideoBlock.js